<script setup>
import {computed, onMounted, ref} from "vue";

const siteUrl = document.querySelector('meta[name="site-url"]').content;

// 現在の URL から特定のクエリを除いた URL を返す
const withoutUrl = param => {
  const params = new URLSearchParams(window.location.search);
  params.delete(param);
  console.log(params);
  return window.location.pathname + (params.toString() ? '?' + params.toString() : '');
};

// 現在の URL からクエリパラメータを取得
const urlParams = new URLSearchParams(window.location.search);

// 現在の URL から order パラメータを除いた URL
const urlWithoutSortParam = withoutUrl('order');

// 現在の URL から filter パラメータを除いた URL
const urlWithoutFilterParam = withoutUrl('filter');

// 現在選択されているソートの種類のラベル
const sortLabel = (() => {
  const SORT_TYPE_LABELS = {
    id: '新着順',
    empathy: '共感順',
    comment: 'コメント順',
  };
  const sort = urlParams.get('order');
  return SORT_TYPE_LABELS[sort] || SORT_TYPE_LABELS['id'];
})();

// 現在「キャンペーン」の絞り込みが適用されているかどうか
const isFilteringCampaign = ref(urlParams.get('filter') === 'campaign');

// 現在「回答募集中」の絞り込みが適用されているかどうか
const isFilteringWanted = ref(urlParams.get('filter') === 'wanted');

// ソート選択の開閉
const isShowSortOptions = ref(false);

onMounted(() => {
  // 疑似セレクトボックス外の要素をクリックした際、疑似セレクトボックスを非表示にする、
  document.addEventListener('click', (event) => {
    if ( ! event.target.closest('.modSelectTrigger')) {
      isShowSortOptions.value = false;
    }
  });
});
</script>

<template>
  <div class="lyPb16">
    <div class="lyHorizontalEnd">
      <p class="lyMr4 lyTbMr8">
        <a
          :href="urlWithoutFilterParam + (isFilteringWanted ? '' : (urlWithoutFilterParam.includes('?') ? '&' : '?') + 'filter=wanted')"
          :class="{lyBlock: true, lyPt8: true, lyPb8: true, lyPr16: true, lyPl16: true, pFont14: true, pFontMedium: true, pFontBlack: true, pBorderRadiusEllipse: true, pHoverBackBlack10: true, pBackColorPink: isFilteringWanted, pBackColorWhite: ! isFilteringWanted, pFontWhite: isFilteringWanted}"
        >回答募集</a>
      </p>
      <div :class="{modSelectTrigger: true, pageSortTriggerLayered: true, isShow: isShowSortOptions}">
        <button
          type="button"
          id="child01"
          class="lyHvCnt lyPt8 lyPb8 lyPr16 lyPl16 pFont14 pFontMedium pFontBlack pBackColorWhite pBorderRadiusEllipse pHoverBackBlack10"
          @click="isShowSortOptions = true"
        >
          {{sortLabel}}
          <span class="lyBlock lyW16px lyMl8">
									<img
                    :src="siteUrl+'images/iconSort.svg'"
                    width="16"
                    height="16"
                    alt="">
								</span>
        </button>
        <div class="modSelectListContainer mdRight">
          <ul class="modSelectList">
            <li class="pBorderBottom1pxSolidGray4 lyHorizontal">
              <a
                :href="urlWithoutSortParam + (urlWithoutSortParam.includes('?') ? '&' : '?') + 'order=id'"
                class="lyW100 lyPt12 lyPb12 lyPr8 lyPl8 lyTextCnt pFontBold pHoverBackGray4 pAnimation pCursorPointer pFontBlack"
              >
                新着順
              </a>
            </li>
            <li class="pBorderBottom1pxSolidGray4 lyHorizontal">
              <a
                :href="urlWithoutSortParam + (urlWithoutSortParam.includes('?') ? '&' : '?') + 'order=empathy'"
                class="lyW100 lyPt12 lyPb12 lyPr8 lyPl8 lyTextCnt pFontBold pHoverBackGray4 pAnimation pCursorPointer pFontBlack"
              >
                共感順
              </a>
            </li>
            <li class="pBorderBottom1pxSolidGray4 lyHorizontal">
              <a
                :href="urlWithoutSortParam + (urlWithoutSortParam.includes('?') ? '&' : '?') + 'order=comment'"
                class="lyW100 lyPt12 lyPb12 lyPr8 lyPl8 lyTextCnt pFontBold pHoverBackGray4 pAnimation pCursorPointer pFontBlack"
              >
                コメント順
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
